import {ReactNode} from 'react';

import {ROLES} from './Menu';

interface Props {
  children: ReactNode;

  // Do not define `_role` -- this is used internally by the component.
  _role: string;
}

/**
 * Renders a section in a Menu: all options, followed by a divider. See Menu implementation.
 *
 * <Section>
 *   <Option>Option 1</Option>
 *   <Option>Option 2</Option>
 * </Section>
 */
export default function Section(props: Props): JSX.Element | null {
  // See Menu implementation -- the children are rendered as is, followed by a divider.
  return null;
}

Section.defaultProps = {
  _role: ROLES.SECTION,
};
